import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { ProfileLayout } from "../../components/layout";
import PrimaryButton from "../../components/button/primarybutton";
import ProfileTab from "../../components/tab/profiletab";
import Spacer from "../../components/spacer/spacer";
import useScreenSize from "../../utils/usescreensize";
import editProfileTabItems from "../../utils/arrayitems/editprofileitems";

import BasicInfo from "./basicinfo";
import PhyscialLifestyle from "./physicallifestyle";
import FamilyDetails from "./familydetails";
import ReligiousStatus from "./religiousstatus";
import EducationCareer from "./educationcareer";
import PersonalityHobby from "./personalityhobby";
import ProfileDescription from "./profiledescription";

import images from "../../assets";

import "./styles.css";

const EditProfile = () => {
  const navigate = useNavigate();
  const screenSize = useScreenSize();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [activeTab, setActiveTab] = useState(
    queryParams.get("tab") ?? "basicInfo"
  );

  useEffect(() => {
    setActiveTab(queryParams.get("tab") ?? "basicInfo");
  }, [location.search]);

  const handleTab = (name) => {
    setActiveTab(name);
    navigate(`/edit-profile?tab=${name}`);
  };

  return (
    <ProfileLayout>
      <div className="edit-profile-container">
        {screenSize.width > 1023 && (
          <>
            <div className="edit-profile-header">
              <div>
                <PrimaryButton
                  text="Back"
                  icon={images.arrowIconLeft}
                  iconalign="left"
                  style={{
                    width: "auto",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    height: "32px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  onClick={() => window.history.back()}
                />
              </div>
              <h2 className="edit-profile-heading">Edit Profile</h2>
            </div>

            <Spacer height="20px" />
          </>
        )}
        <ProfileTab
          tabItems={editProfileTabItems}
          handleTab={handleTab}
          activeTab={activeTab}
        />

        <Spacer height="32px" />
        <div className="edit-profile-content-container">
          {activeTab === "physicalLifestyle" ? (
            <PhyscialLifestyle handleTab={handleTab} />
          ) : activeTab === "familyDetails" ? (
            <FamilyDetails handleTab={handleTab} />
          ) : activeTab === "religiousStatus" ? (
            <ReligiousStatus handleTab={handleTab} />
          ) : activeTab === "educationCareer" ? (
            <EducationCareer handleTab={handleTab} />
          ) : activeTab === "personalityHobbies" ? (
            <PersonalityHobby handleTab={handleTab} />
          ) : activeTab === "profileDesc" ? (
            <ProfileDescription handleTab={handleTab} />
          ) : (
            <BasicInfo handleTab={handleTab} />
          )}
        </div>
        <Spacer height="32px" />
      </div>
    </ProfileLayout>
  );
};

export default EditProfile;
